import { defineMessages } from 'react-intl';

export default defineMessages({
  fieldMessageOptionalLabel: {
    id: '',
    description: 'Label for document message',
    defaultMessage: 'Message (optional)',
  },
  fieldMessageLabel: {
    id: '',
    description: 'Label for document message',
    defaultMessage: 'Message',
  },
  fieldEmailLabel: {
    id: '',
    description: 'Label for document message',
    defaultMessage: 'Email message (Optional)',
  },
  fieldCCRoleLabel: {
    id: '',
    description: 'Label for CC Email',
    defaultMessage: 'CC recipient role',
  },
  fieldCCRecipientLabel: {
    id: '',
    description: 'Label for Recipient Email',
    defaultMessage: "Recipient's email address",
  },
  headerSignerRoles: {
    id: '',
    description: 'Header for signer rows section',
    defaultMessage: 'Signer roles',
  },
  headerSigners: {
    id: '',
    description: 'Header for signers section',
    defaultMessage: 'Signers',
  },
  headerMergeFields: {
    id: '',
    description: 'Header for merge fields section',
    defaultMessage: 'Merge fields',
  },
  headerDefaultDocumentSection: {
    id: '',
    description: 'Default header for Document Section',
    defaultMessage: 'Message to signers',
  },
  firstNamePlaceholder: {
    id: '',
    description: 'placeholder for first name input',
    defaultMessage: 'Your first name',
  },
  lastNamePlaceholder: {
    id: '',
    description: 'placeholder for first name input',
    defaultMessage: 'Your last name',
  },
  fromToolTip: {
    id: '',
    description: 'tooltip message, informing sender can always change the change from settings',
    defaultMessage: 'You can always change your name later in your settings',
  },
  headerTemplateDocumentSection: {
    id: '',
    description: 'Header for Document Section for create template flow',
    defaultMessage: 'Add a title and default message for signers',
  },
  headerTemplateLinkDocumentSection: {
    id: '',
    description: 'Header for Document Section for create template link flow',
    defaultMessage: 'Name your template link',
  },
  delete: {
    id: '',
    description: 'Delete',
    defaultMessage: 'Delete',
  },
  addFaxRecipientButton: {
    id: '',
    description: 'Add fax recipient button',
    defaultMessage: 'Add additional recipient',
  },
  downloadDocumentButton: {
    id: '',
    description: 'Download document button',
    defaultMessage: 'Download document',
  },
  headerDownloadDocument: {
    id: '',
    description: 'Download document header',
    defaultMessage: 'Save to your computer',
  },
  headerDefaultReview: {
    id: '',
    description: 'Default header for Review',
    defaultMessage: 'Does everything look right?',
  },
  headerFaxReview: {
    id: '',
    description: 'Header for Fax Request Review page',
    defaultMessage: 'Who should receive a copy?',
  },
  headerMeOnlyFlowReview: {
    id: '',
    description: 'Header for Just me flow Review',
    defaultMessage: 'Save or send your completed document',
  },
  firstNameError: {
    id: '',
    description: 'text for required first name field error for signer info modal',
    defaultMessage: 'First Name is required',
  },
  lastNameError: {
    id: '',
    description: 'text for required last name field error for signer info modal',
    defaultMessage: 'Last Name is required',
  },
  submitButton: {
    id: '',
    description: 'pre-send basic profile modal submit button for signer info modal',
    defaultMessage: 'Send document',
  },
  cancelButton: {
    id: '',
    description: 'pre-send basic profile modal cancel button for signer info modal',
    defaultMessage: 'Cancel',
  },
  contentTitle: {
    id: '',
    description: 'title for template picker for prep and send for signer info modal',
    defaultMessage: 'Since this is your first fax...',
  },
  headerFaxRecipientSection: {
    id: '',
    description: 'text for fax recipients section header',
    defaultMessage: 'Recipients',
  },
  sendHighResolutionFaxCheckbox: {
    id: '',
    description: 'text for send high resolution fax checkbox',
    defaultMessage: 'Send high resolution and color version of fax. ',
  },
  addCoverPage: {
    id: '',
    description: 'text for add cover page checkbox',
    defaultMessage: 'Add a cover page',
  },
  coverPageToLabel: {
    id: '',
    description: 'text for cover page to label',
    defaultMessage: 'To',
  },
  coverPageFromLabel: {
    id: '',
    description: 'text for cover page from label',
    defaultMessage: 'From',
  },
  coverPageMessageLabel: {
    id: '',
    description: 'text for cover page message label',
    defaultMessage: 'Message',
  },
  headerIncludeOtherSecion: {
    id: '',
    description: 'text for header of Include Other items section',
    defaultMessage: 'Include any other items?',
  },
  headerFaxDocument: {
    id: '',
    description: 'text for header of fax document section',
    defaultMessage: 'Optional message and document title for email recipients',
  },
  learnMoreLabel: {
    id: '',
    description: 'text for learn more label',
    defaultMessage: 'Learn more',
  },
  backendValidationError: {
    id: '',
    description: 'text for displaying a validation error identified by the backend',
    defaultMessage: 'The following error was encountered: {error}',
  },
  title: {
    id: '',
    description: 'Title for a modal that tells you to upgrade to fax multiple recipients',
    defaultMessage: 'Upgrade to fax to multiple recipients',
  },
  upgrade: {
    id: '',
    description: 'Title for a button that will take you to the pricing page to upgrade your version of HelloFax',
    defaultMessage: 'Upgrade',
  },
  cancel: {
    id: '',
    description: 'text for upgrade-to-send-multi-fax modal that closes the modal to let you edit your request',
    defaultMessage: 'Close',
  },
  review: {
    id: '',
    description: 'Review',
    defaultMessage: 'Review',
  },
  templatePreviewButton: {
    id: '',
    description: `text for button on review page when using a template that lets you preview how the document will
    appear to different recipients`,
    defaultMessage: 'Preview document as signer',
  },
  templatePreviewLink: {
    id: '',
    description: `text for link on review page when using a template that lets you preview how the document will
    appear to different recipients`,
    defaultMessage: 'Test signer view',
  },
  templatePreviewErrorTooltip: {
    id: '',
    description: `text for a tooltip over the template preview button on the review page that indicates that the template preview
    feature is not currently available, so they should try refreshing`,
    defaultMessage: 'Template Preview is not currently available. Please try again later.',
  },
  filesAreStillLoading: {
    id: '',
    description: 'The tooltip on the stepper on the review page when files are still loading.',
    defaultMessage: 'Your files are still uploading!',
  },
  mergeFieldOverflow: {
    id: '',
    description: 'Validation error for when a merge field contains too much text',
    defaultMessage: 'Text has exceeded the current field size. Increase the field size in your template or reduce the amount of text.',
  },
});
